import classNames from 'classnames';

import LoadingIcon from './LoadingIcon';

import styles from '../../styles/icons/toggle-icon.module.css';

interface ToggleIconProps {
    checked?: boolean;
    loading?: boolean;
    className?: string;
}

function ToggleIcon({ checked = false, loading = false, className }: ToggleIconProps) {
    return (
        <span
            className={classNames([
                styles.container,
                {
                    [styles.loading]: loading,
                    [styles.checked]: checked,
                },
                className,
            ])}
        >
            <span className={styles.control}>
                <span className={styles.knob}>
                    {loading ? <LoadingIcon className={styles.loadingIcon} /> : null}
                </span>
            </span>
        </span>
    );
}

export default ToggleIcon;
